import { CHANGE_SHIPMENT_DETAIL, GET_DETAIL_SHIPMENT_FAILS, GET_DETAIL_SHIPMENT_SUCCESS, RESET_STATE_SHIPMENT_DETAIL } from './../actions/detailShipment';
import { SHIPPER_INFOR_SUCCESS } from '../actions/shipperInfor';
import { informationDefault } from './helper/stateDefaultOrder';

const initialState = {
    shipment: [],
    packages: [],
    isLoading: true,
    shipperInformation: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_DETAIL_SHIPMENT_SUCCESS:
            let shipment = action.payload.data.data.Shipment
            let packages = shipment.Packages

            return {
                ...state,
                shipment,
                packages,
                isLoading: false
            }

        case CHANGE_SHIPMENT_DETAIL:
            return {
                ...state,
                [action.payload.column]: action.payload.value
            }

        case GET_DETAIL_SHIPMENT_FAILS:
            return {
                ...state,
                isLoading: false
            }

        case RESET_STATE_SHIPMENT_DETAIL:
            return {
                ...state,
                shipment: [],
                packages: []
            }

        case SHIPPER_INFOR_SUCCESS:
            let shipperInfor = action.payload.data.data
            return {
                ...state,
                shipperInformation: {
                    currency: shipperInfor.DefaultCurrencyCH,
                    defaultPaymentTerm: shipperInfor.DefaultPaymentTermCH,
                    paymentTerms: shipperInfor.PaymentTermsCH,
                    destinationCountriesCH: shipperInfor.DestinationCountryCH,
                    handlingChargeFlg: shipperInfor.HandlingChargeFlg
                },
            }

        default:
            return state
    }
}




// WEBPACK FOOTER //
// ./src/reducers/detailShipment.js